export enum ProcessExceptions {
    WITHOUT_PERMISSION_TO_PUBLISH_AUCTION = 'WITHOUT_PERMISSION_TO_PUBLISH_AUCTION',
    PROPONENT_DIDNT_SEND_PROPOSAL = 'PROPONENT_DIDNT_SEND_PROPOSAL',
    PROCESS_INVITES_NOT_SENDED = 'PROCESS_INVITES_NOT_SENDED',
    CANNOT_PUBLISH_UNENFORCEABILITY_PROCESS_WITHOUT_LOT = 'CANNOT_PUBLISH_UNENFORCEABILITY_PROCESS_WITHOUT_LOT',
}
